import { useState, useEffect } from "react";
import PageHeader from "../../components/common/PageHeader";
import DetailsSection from "./components/DetailsSection";
import PrintersSection from "./components/PrintersSection";
import RejectReasonsSection from "./components/RejectReasonsSection";
import api from "../../utils/api";
import { API_BASE } from "../../utils/api";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Setting = () => {
  const [details, setDetails] = useState({
    name: "",
    address: "",
    contact: "",
    whatsapp: "",
    gst: "",
    licenseNumber: "",
    taxType: "",
    gstRate: "",
    openingTime: "",
    closingTime: "",
  });

  const [printers, setPrinters] = useState([]);

  // Multi-language state for name + address
  const [editOtherLang, setEditOtherLang] = useState(false);
  const [languages, setLanguages] = useState([]);
  const [selectedLang, setSelectedLang] = useState("en");
  const [translations, setTranslations] = useState({});
  const [isSaving, setIsSaving] = useState(false);
  const [printCategories, setPrintCategories] = useState([]);
  const [logoFile, setLogoFile] = useState(null);
const [defaultFile, setDefaultFile] = useState(null);

const [logoPreview, setLogoPreview] = useState(null);
const [defaultPreview, setDefaultPreview] = useState(null);

  useEffect(() => {
    const loadDetails = async () => {
      try {
        const res = await api.get("/settings/loaddetails");

        if (res.data.success) {
          const { details, printers, nameByLang = {}, addressByLang = {} } =
            res.data.data;

          setDetails(details);
          if (details.logo) {
  setLogoPreview(`${API_BASE}${details.logo}`);
}

if (details.defaultImage) {
  setDefaultPreview(`${API_BASE}${details.defaultImage}`);
}

          // Initialize translations map (including English)
          const initialTranslations = {};
          Object.keys(nameByLang).forEach((code) => {
            initialTranslations[code] = {
              name: nameByLang[code] || "",
              address: addressByLang[code] || "",
            };
          });

          // Ensure English fallback even if backend didn't send full map
          if (!initialTranslations.en) {
            initialTranslations.en = {
              name: details.name || "",
              address: details.address || "",
            };
          }

          setTranslations(initialTranslations);

          const formattedPrinters = printers.map((p, idx) => ({
            ...p,
            // Own copy of categories so printers don't share the same array reference
            categories: Array.isArray(p.categories) ? [...p.categories] : [],
            _localId: p.id || p._id?.$oid || `p_${Date.now()}_${idx}_${Math.random().toString(16).slice(2)}`,
          }));

          setPrinters(formattedPrinters);
        }
      } catch (err) {
        console.error("Failed to load settings", err);
      }
    };

    const loadPrintCategories = async () => {
  try {
    const res = await api.get("/restaurant/loadPrintCatagories");

    // remove kitchen category
    const filtered = (res.data || []).filter(c => c.key !== "kitchen");

    setPrintCategories(filtered);
  } catch (err) {
    console.error("Failed to load print categories", err);
  }
};

    const loadLanguages = async () => {
      try {
        const res = await fetch(
          `${API_BASE}/api/languages/availableLanguages`,
        );
        const data = await res.json();
        setLanguages(data || []);
      } catch (err) {
        console.error("Failed to load languages", err);
      }
    };

    loadDetails();
    loadLanguages();
    loadPrintCategories();
  }, []);

  const handleDetailsChange = (field, value) => {
    setDetails((prev) => ({
      ...prev,
      [field]: value,
    }));

    // Keep English translations in sync with main fields
    if (field === "name" || field === "address") {
      setTranslations((prev) => ({
        ...prev,
        en: {
          ...(prev.en || {}),
          [field]: value,
        },
      }));
    }
  };
  const handleImageChange = (e, type) => {

  const file = e.target.files[0];
  if (!file) return;

  const preview = URL.createObjectURL(file);

  if (type === "logo") {
    setLogoFile(file);
    setLogoPreview(preview);
  }

  if (type === "default") {
    setDefaultFile(file);
    setDefaultPreview(preview);
  }
};

  const handleAddPrinter = () => {
    setPrinters((prev) => [
      ...prev,
      {
        _localId: `p_${Date.now()}_${Math.random().toString(16).slice(2)}`,
        name: "",
        ip: "",
        port: "9100",
        type: "customer", // "customer" | "kitchen"
        categories: [], // only for kitchen; optional
        isEnabled: true,
      },
    ]);
  };

  const handleChangePrinter = (index, field, value) => {
    setPrinters((prev) =>
      prev.map((p, i) => {
        if (i !== index) return p;

       if (field === "categories") {
  return { ...p, categories: value };
}

        if (field === "type") {
          const next = { ...p, type: value };
          return next;
        }

        if (field === "port") {
          return { ...p, port: value };
        }

        return { ...p, [field]: value };
      }),
    );
  };

  const handleRemovePrinter = (index) => {
    setPrinters((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSaving) return;

    const requiredFields = [
      { key: "name", label: "Name" },
      { key: "address", label: "Address" },
      { key: "contact", label: "Contact number" },
      { key: "whatsapp", label: "WhatsApp number" },
      { key: "taxType", label: "Tax type" },
      { key: "gstRate", label: "Tax rate" },
      { key: "openingTime", label: "Opening time" },
      { key: "closingTime", label: "Closing time" },
    ];

    for (const field of requiredFields) {
      const value = (details[field.key] ?? "").toString().trim();
      if (!value) {
        toast.error(`${field.label} is required`);
        return;
      }
    }

    const gstRateNumber = Number(details.gstRate);
    if (!Number.isFinite(gstRateNumber) || gstRateNumber < 0) {
      toast.error("Tax rate must be a valid non-negative number");
      return;
    }


    const nameByLang = {};
    const addressByLang = {};

    Object.entries(translations || {}).forEach(([code, value]) => {
      if (value?.name) {
        nameByLang[code] = value.name;
      }
      if (value?.address) {
        addressByLang[code] = value.address;
      }
    });

   const formData = new FormData();

formData.append("details", JSON.stringify(details));

formData.append(
  "printers",
  JSON.stringify(
    printers.map((p) => ({
      name: p.name,
      ip: p.ip,
      port: p.port,
      type: p.type,
      categories: p.categories,
      isEnabled: p.isEnabled,
    }))
  )
);

formData.append("nameByLang", JSON.stringify(nameByLang));
formData.append("addressByLang", JSON.stringify(addressByLang));

if (logoFile) {
  formData.append("logo", logoFile);
}

if (defaultFile) {
  formData.append("defaultImage", defaultFile);
}

    setIsSaving(true);
    try {
      const res = await api.post("/settings/update", formData, {
  headers: {
    "Content-Type": "multipart/form-data",
  },
});
      const message =
        res?.data?.message || "Settings updated successfully";
      toast.success(message);

      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } catch (err) {
      console.error("Failed to save settings", err);
      const message =
        err?.response?.data?.message || "Failed to update settings";
      toast.error(message);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div>
      <PageHeader
        showBackButton={true}
        backTo={-1}
        title="Settings"
        subtitle="Manage your application settings"
      />

      <form
        onSubmit={handleSubmit}
        className="mt-6 space-y-6 pb-24 sm:pb-6"
        style={{ paddingBottom: "calc(6rem + env(safe-area-inset-bottom))" }}
      >
        <DetailsSection
          details={details}
          onChange={handleDetailsChange}
          editOtherLang={editOtherLang}
          setEditOtherLang={setEditOtherLang}
          languages={languages}
          selectedLang={selectedLang}
          setSelectedLang={setSelectedLang}
          translations={translations}
          setTranslations={setTranslations}
            logoPreview={logoPreview}
  defaultPreview={defaultPreview}
  onImageChange={handleImageChange}
        />
        <PrintersSection
          printers={printers}
           categories={printCategories}
          onAddPrinter={handleAddPrinter}
          onChangePrinter={handleChangePrinter}
          onRemovePrinter={handleRemovePrinter}
        />

        <RejectReasonsSection />

        <div
          className="sticky bottom-0 z-10 -mx-2 px-2 pt-3 pb-4 sm:mx-0 sm:px-0 flex justify-center bg-white/90 backdrop-blur border-t border-gray-100 rounded-b-2xl"
          // style={{ paddingBottom: "calc(1rem + env(safe-area-inset-bottom))" }}
        >
          <button
            type="submit"
            disabled={isSaving}
            className={`bg-blue-600 hover:bg-blue-700 text-white px-6 py-2.5 rounded-xl text-sm font-semibold active:scale-[0.98] transition-all duration-200 flex items-center gap-2 ${isSaving ? "opacity-70 cursor-not-allowed" : ""
              }`}
          >
            {isSaving ? (
              <>
                <svg
                  className="w-4 h-4 animate-spin"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 12a8 8 0 018-8"
                  />
                </svg>
                Saving...
              </>
            ) : (
              <>
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
                Save Settings
              </>
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default Setting;
